import { create } from 'zustand';
import { debounce } from 'lodash';

type CreateSpotifyReportStore = {
	reportActionsOpenId?: string;
	setReportActionsOpenId: (reportId?: string) => void;
};

const useReportActionsOpen = create<CreateSpotifyReportStore>(((set) => ({
	reportActionsOpenId:    undefined,
	setReportActionsOpenId: debounce((reportId?: string) => set({ reportActionsOpenId: reportId }), 100),
})));

export default useReportActionsOpen;
